import { LogOperation } from '../../types';

interface AgentFilterProps {
  agents: string[];
  workspaces: string[];
  selectedAgent?: string;
  selectedWorkspace?: string;
  selectedOperation?: LogOperation;
  onAgentChange: (agent?: string) => void;
  onWorkspaceChange: (workspace?: string) => void;
  onOperationChange: (operation?: LogOperation) => void;
  onClear: () => void;
}

const operations: { value: LogOperation; label: string }[] = [
  { value: 'read_file', label: 'Read File' },
  { value: 'write_file', label: 'Write File' },
  { value: 'list_directory', label: 'List Directory' },
  { value: 'get_file_url', label: 'Get File URL' },
];

export function AgentFilter({
  agents,
  workspaces,
  selectedAgent,
  selectedWorkspace,
  selectedOperation,
  onAgentChange,
  onWorkspaceChange,
  onOperationChange,
  onClear,
}: AgentFilterProps) {
  return (
    <div className="flex items-center gap-4 flex-wrap">
      <div>
        <label className="block text-xs text-gray-500 mb-1">Agent</label>
        <select
          value={selectedAgent || ''}
          onChange={(e) => onAgentChange(e.target.value || undefined)}
          className="px-3 py-1.5 border rounded-lg text-sm focus:ring-2 focus:ring-primary-500 focus:border-transparent"
        >
          <option value="">All agents</option>
          {agents.map((agent) => (
            <option key={agent} value={agent}>
              {agent}
            </option>
          ))}
        </select>
      </div>

      <div>
        <label className="block text-xs text-gray-500 mb-1">Workspace</label>
        <select
          value={selectedWorkspace || ''}
          onChange={(e) => onWorkspaceChange(e.target.value || undefined)}
          className="px-3 py-1.5 border rounded-lg text-sm focus:ring-2 focus:ring-primary-500 focus:border-transparent"
        >
          <option value="">All workspaces</option>
          {workspaces.map((ws) => (
            <option key={ws} value={ws}>
              {ws}
            </option>
          ))}
        </select>
      </div>

      <div>
        <label className="block text-xs text-gray-500 mb-1">Operation</label>
        <select
          value={selectedOperation || ''}
          onChange={(e) =>
            onOperationChange((e.target.value as LogOperation) || undefined)
          }
          className="px-3 py-1.5 border rounded-lg text-sm focus:ring-2 focus:ring-primary-500 focus:border-transparent"
        >
          <option value="">All operations</option>
          {operations.map((op) => (
            <option key={op.value} value={op.value}>
              {op.label}
            </option>
          ))}
        </select>
      </div>

      <div className="flex items-end">
        <button
          onClick={onClear}
          className="px-3 py-1.5 text-sm text-gray-600 hover:text-gray-800"
        >
          Clear all
        </button>
      </div>
    </div>
  );
}
